import $ from 'jquery';

// Many IhmAssociateToolsJSLib Service Clients are jquery coral clients,
// which uses @amzn/ihm-coral-config (IhmJSCoralConfig = 1.2), which is deprecated
// IhmJSCoralConfig expects $ (jquery) to be globally accessible (in the window property)
// This is a mitigation until IhmAssociateToolsJSLib stops using jquery coral clients
// and start using TypeScript generated clients instead
// See: https://code.amazon.com/packages/CoralTypescriptTypesBuildLogic
// See: https://tiny.amazon.com/121g6iuim/wamazbinviewIHMCOSMMercProj
(window as any).$ = $;

// AppInfoLoader
import { AppInfoLoader, IAppInfoType } from '@src/services/AppInfoLoader';

export { AppInfoLoader, IAppInfoType };

// RegionMappingService
import { RegionMappingService } from '@src/services/RegionMappingService';

export { RegionMappingService };

// RemoteFileLoader
import { RemoteFileLoader } from '@src/services/RemoteFileLoader';

export { RemoteFileLoader };

// LODChecklistService
import { LODChecklistService } from '@src/services/LODChecklistService';

export { LODChecklistService };

// ATBaseClient
import { ATBaseClient } from '@src/services/ATBaseClient';

export { ATBaseClient };

// AuthenticatedRequestClient
import { AuthenticatedRequestsClient } from '@src/services/AuthenticatedRequestsClient';

export { AuthenticatedRequestsClient };

// Timeline
import { Timeline } from '@src/services/Timeline';

export { Timeline };

// AssociateAuditTrailService
import { AssociateAuditTrailService, IBaseAuditEvent } from '@src/services/AssociateAuditTrailService';

export { AssociateAuditTrailService, IBaseAuditEvent };

// AssociateDurationService
import { AssociateDurationService } from '@src/services/AssociateDurationService';

export { AssociateDurationService };

// createTypeScriptClient
import { createTypeScriptClient } from '@src/services/typeScriptClientGenerator/createTypeScriptClient';
export { createTypeScriptClient };

// ATConfigService
import { ATConfigService } from '@src/services/ATConfigService';

export { ATConfigService };

// ToolHeartbeatService
import { ToolHeartbeatService } from '@src/services/ToolHeartbeatService';

export { ToolHeartbeatService };

// InterruptService
import { InterruptService } from '@src/services/InterruptService';

export { InterruptService };

// EventHandle
import { EventHandle } from '@src/services/EventHandle';

export { EventHandle };

// AtAlertService
import { AtAlertService } from '@src/services/AtAlertService';

export { AtAlertService };

import { ApplicationTimeline } from '@src/services/ApplicationTimeline';

export { ApplicationTimeline };

import { AssociateAppEvent } from '@src/services/AssociateAppEvent';

export { AssociateAppEvent };

import { InputFieldValidationException, InputFieldNotSetException, InputField, InputFieldBuilder } from '@src/services/InputField';

export { InputField, InputFieldBuilder, InputFieldNotSetException, InputFieldValidationException };

// WeblabService
import { WeblabService } from '@src/services/WeblabService';

export { WeblabService };

// ShelfTagService
import { ShelfTagService } from '@src/services/ShelfTagService';

export { ShelfTagService };

import { MasterIndirectTaskService } from '@services/MasterIndirectTaskService';

export { MasterIndirectTaskService };

// AssistedShoppingBarcodeService
import { reset, startHexProfile, capture } from '@services/barcode/assistedShoppingBarcodeService';

export { capture, reset, startHexProfile };

import { StoreFamilyService } from '@services/StoreFamilyService';

export { StoreFamilyService };

export * from '../utils/ToolRedirectionUtils';
export * from './barcode/index';
export * from './bluetooth/index';
export * from './bluetoothLowEnergy/index';
export * from './camera/index';
export * from './coralservices/index';
export * from './networkPrinting/index';
export * from './sxclient/index';
export * from './translation/index';
export * from './voice/index';

// TaskWorkflowEmitter
import { createTaskWorkflow, TaskWorkflowConfig, TaskWorkflowEvent } from '@src/services/TaskWorkflowEmitter';

export { createTaskWorkflow, TaskWorkflowConfig, TaskWorkflowEvent };
